<template>

    <div class="row">
        <div class="form-group">
            <label>
                <input v-model="props.data.checkboxCredit" type="checkbox" name="FounderFLIsBeneficiary"
                    :disabled="disabled">
                <span>Имеются обязательства по кредитам, займам</span>
            </label>
        </div>

    </div>

    <div v-if="props.data.checkboxCredit" v-for="(item, index) in Credit" :key="index" class="mt-3">

        <div class="row">
            <div class="col-md-8 col-lg-6">

                <!-- <ui-input-box-floating class="mb-3" :error="getError(index, 'Creditor')">
                    <ui-input v-model="item.Creditor" type="text" placeholder="Наименование кредитора"  :disabled="disabled"/>
                    <ui-input-label>Наименование кредитора</ui-input-label>
                </ui-input-box-floating> -->


                <Autocomplete class="mb-3" v-model="item.Creditor" type="party" label="Наименование кредитора"
                    placeholder="Наименование кредитора" :error="getError(index, 'Creditor')" :disabled="disabled"
                    @select="(d) => {
                        item.Creditor = d.value || ''
                    }" />

                <ui-input-box-floating class="mb-3" :error="getError(index, 'CreditEndDate')">
                    <ui-input v-model="item.CreditEndDate" type="date" placeholder="Дата окончания договора"
                        :disabled="disabled" />
                    <ui-input-label>Дата окончания договора</ui-input-label>
                </ui-input-box-floating>

                <div class="row">

                    <div class="col-md-6">

                        <ui-input-box-floating class="mb-3" :error="getError(index, 'CreditAmount')">
                            <ui-input v-model="item.CreditAmount" type="text" placeholder="Сумма договора"
                                :disabled="disabled" />
                            <ui-input-label>Сумма договора</ui-input-label>
                        </ui-input-box-floating>

                    </div>

                    <div class="col-md-6">

                        <ui-input-box-floating class="mb-3" :error="getError(index, 'CreditBalance')">
                            <ui-input v-model="item.CreditBalance" type="text" placeholder="Остаток задолженности"
                                :disabled="disabled" />
                            <ui-input-label>Остаток задолженности</ui-input-label>
                        </ui-input-box-floating>

                    </div>



                </div>

            </div>

        </div>

        <button @click="() => del(index)" class="btn btn-ghost btn-small mb-2"
            :disabled="Credit.length == 1 || disabled">Удалить информацию по другому
            кредитору</button>
    </div>

    <button v-if="props.data.checkboxCredit" @click="add" class="btn btn-base btn-small" :disabled="disabled">Добавить
        информацию по другому
        кредитору</button>
</template>

<script setup>

import { ref, onMounted, watch } from 'vue'

import Autocomplete from "../../../component/Autocomplete/index.vue";

const props = defineProps({
    data: {
        type: Object,
        default: {}
    },
    errors: {
        type: Object,
        default: {}
    },
    disabled: {
        type: Boolean,
        default: false
    }
})

const Credit = ref([])

const add = () => {
    Credit.value = [...Credit.value, {}]
}

const del = (index) => {
    Credit.value = Credit.value.filter((item, itemIndex) => itemIndex !== index)
}

const getError = (index, field) =>
    props.errors?.Credit?.[index]?.[field] || false

onMounted(async () => {

    const isValidObjectArray = Array.isArray(props.data?.Credit) && props.data.Credit.every(item => typeof item === 'object' && !Array.isArray(item))

    Credit.value = isValidObjectArray ? props.data.Credit : [{}]

})

watch(Credit, (newValue) => {

    props.data.Credit = newValue

}, { deep: true })


watch(() => props.data.checkboxCredit, (newVal) => {
    if (newVal) {
        Credit.value = [
            {}
        ];
    }
});


</script>